export function splitArray(arr, len) {
    let result = [];
    let a_len = arr.length;
    for (let i = 0; i < a_len; i += len) {
        result.push(arr.slice(i, i + len));
    }
    return result;
}